export const DUMMY_URL = 'http://localhost:8000';
export const LIVE_IMG_URL = 'https://upl-snipe.ap-south-1.linodeobjects.com';